import { createContext, useContext, useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [liveEpisodes, setLiveEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Categories listener
    const unsubscribeCategories = onSnapshot(
      doc(db, "content", "main"),
      (docSnap) => {
        setCategories(docSnap.data()?.categories || []);
      }
    );

    // Series collection listener
    const seriesRef = collection(db, "content", "main", "series");
    const unsubscribeSeries = onSnapshot(seriesRef, (seriesSnapshot) => {
      const seriesData = seriesSnapshot.docs.map((seriesDoc) => ({
        id: seriesDoc.id,
        ...seriesDoc.data(),
      }));

      setSeries(seriesData);
      setLoading(false);
    });

    // Live episodes listener
    const liveEpisodesQuery = query(
      collection(db, "episodes"),
      where("isLive", "==", true)
    );

    const unsubscribeLiveEpisodes = onSnapshot(
      liveEpisodesQuery,
      (snapshot) => {
        const liveEpisodesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setLiveEpisodes(liveEpisodesData);
      }
    );

    return () => {
      unsubscribeCategories();
      unsubscribeSeries();
      unsubscribeLiveEpisodes();
    };
  }, []);

  const contextValue = {
    categories,
    series,
    liveEpisodes,
    loading,
  };

  return (
    <ContentContext.Provider value={contextValue}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
